import React, {useState} from "react";
import {TableCell, TableRow, Typography} from "@material-ui/core";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import WorkableIconForwardButton from "components/button/WorkableIconForwardButton";
import WorkableIconConfirmButton from "components/button/WorkableIconConfirmButton";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import {AuctionRule, AuctionRuleLabel} from "constants/AuctionRule";
import {AuctionStatusLabel} from "constants/AuctionStatus";
import {AuctionTypeLabel} from "constants/AuctionType";
import TooltipIcon from "components/icon/TooltipIcon";
import Tr from "translations/Translations";
import {getUserFullNameWithEmail} from "libs/userNameGetter";
import Confirm from "components/popup/confirm/Confirm";
import openInNewTab from "libs/openInNewTab";


function TooltipRow(
    {
        label,
        value
    }) {
    return <Typography><strong>{Tr(label)}</strong>: {value}</Typography>
}


function AuctionRow(
    {
        auction,
        handleAssignToAuction,
        classes,
    }) {

    const [confirmOpened, setConfirmOpened] = useState(false);

    return (<TableRow>
        <TableCell>{auction.auctionId}</TableCell>
        <TableCell>{auction.name}</TableCell>
        <TableCell>{AuctionTypeLabel(auction.type)}</TableCell>
        <TableCell>{getUserFullNameWithEmail(auction.user)}</TableCell>
        <TableCell>{moment(auction.startDate).format(DateFormats.DATETIME_FORMAT)}</TableCell>
        <TableCell>{AuctionStatusLabel(auction.status)}</TableCell>
        <TableCell>
            <TooltipIcon tooltipClasses={{tooltip: classes.customWidth}} Icon={HelpOutlineIcon} tooltip={<>
                <TooltipRow label={'auction_overtime'} value={auction.overtime}/>
                <TooltipRow label={'auction_overtime_count'} value={auction.overtimeCount}/>
                <TooltipRow label={'auction_rule'} value={AuctionRuleLabel(auction.rule)}/>
                {[AuctionRule.JAPANESE, AuctionRule.DUTCH].includes(auction.rule) && <TooltipRow label={'auction_decision_time'} value={auction.decisionTime}/>}
                <TooltipRow label={'auction_end_date'} value={moment(auction.endDate).format(DateFormats.DATETIME_FORMAT)}/>
            </>}></TooltipIcon>
        </TableCell>
        <TableCell className={classes.buttonColumn}>
            {!!auction.user && !!auction.url &&
                <WorkableIconForwardButton onClick={() => openInNewTab(auction.url)}/>
            }
            {!auction.user &&
                <WorkableIconConfirmButton tooltip={Tr('auction_assign_to_auction')} onClick={() => setConfirmOpened(true)}/>
            }
            {!auction.user &&
                <Confirm confirmText='auction_assign_to_auction_confirm'
                         onCancel={() => setConfirmOpened(false)}
                         onConfirm={() => handleAssignToAuction(auction.auctionId)}
                         open={confirmOpened}
                />
            }
        </TableCell>
    </TableRow>)
}

AuctionRow.propTypes = {};

export default AuctionRow;

